export const PRODUCT_WEBSITE = 'leadster_website';
export const PRODUCT_WHATSAPP = 'leadster_whatsapp';

export const SCRIPTS_KIND_STORAGE_KEY = 'leadster.scriptsScriptKind';

export const RAIL_WIDTH = '3.25rem';
export const PANEL_WIDTH = '15rem';
export const PANEL_COLLAPSED_WIDTH = '4.5rem';
export const SIDEBAR_WIDTH = `calc(${RAIL_WIDTH} + ${PANEL_WIDTH})`;
export const SIDEBAR_COLLAPSED_WIDTH = `calc(${RAIL_WIDTH} + ${PANEL_COLLAPSED_WIDTH})`;
export const SIDEBAR_MD_BREAKPOINT_PX = 768;

export const ACCENT = {
  blue: '#007DFF',
  green: '#1CAE4A',
};

export const SIDEBAR_ASSETS = {
  mark: '/images/sidebar/rail-mark.svg',
  websiteIcon: '/images/sidebar/product-website.svg',
  whatsappIcon: '/images/sidebar/product-whatsapp.svg',
  websiteLogo: '/images/sidebar/logo-leadster-website.svg',
  whatsappLogo: '/images/sidebar/logo-leadster-whatsapp.png',
  websiteLogoDark: '/images/sidebar/logo-leadster-website-white.svg',
  whatsappLogoDark: '/images/sidebar/logo-leadster-whatsapp-white.png',
};

export const HELP_CENTER_URL =
  'https://help.leadster.com.br/collection/314-whatsapp-suite';

export function accentColor(accent) {
  return ACCENT[accent] || ACCENT.blue;
}

export function sidebarOffset(collapsed) {
  return collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;
}
